import { render, staticRenderFns } from "./ChannelFans.vue?vue&type=template&id=49600728&scoped=true&"
import script from "./ChannelFans.vue?vue&type=script&lang=js&"
export * from "./ChannelFans.vue?vue&type=script&lang=js&"
import style0 from "./ChannelFans.vue?vue&type=style&index=0&id=49600728&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49600728",
  null
  
)

export default component.exports